export enum MutationTypes {
  SET_USER = 'SET_USER',
  SET_TOKEN = 'SET_TOKEN',
  SET_ROUTES = 'SET_ROUTES',
  SET_MODAL = 'SET_MODAL',
  SET_ERROR_MODAL = 'SET_ERROR_MODAL',
  SET_LOADING = 'SET_LOADING',
  SET_FAVORITE_COURSES = 'SET_FAVORITE_COURSES',
  SET_ACTIVE_PROJECT = 'SET_ACTIVE_PROJECT',
  SET_ACTIVE_PRODUCT = 'SET_ACTIVE_PRODUCT',
  SET_ACTIVE_LANG = 'SET_ACTIVE_LANG',
  SET_SHOW_LABS = 'SET_SHOW_LABS'
}
